import { render, staticRenderFns } from "./AppAiAssessmentRoot.vue?vue&type=template&id=374520da&scoped=true"
import script from "./AppAiAssessmentRoot.vue?vue&type=script&lang=ts"
export * from "./AppAiAssessmentRoot.vue?vue&type=script&lang=ts"
import style0 from "./AppAiAssessmentRoot.vue?vue&type=style&index=0&id=374520da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374520da",
  null
  
)

export default component.exports